import { render, staticRenderFns } from "./OverallSetting.vue?vue&type=template&id=77285de4&scoped=true&"
import script from "./OverallSetting.vue?vue&type=script&lang=js&"
export * from "./OverallSetting.vue?vue&type=script&lang=js&"
import style0 from "./OverallSetting.vue?vue&type=style&index=0&id=77285de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77285de4",
  null
  
)

export default component.exports